import { useEffect, useMemo, useState } from "react";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";
import { dayjs } from "../../util/dayjs";
import { Row } from "../../components/Row";
import { BQATabs } from "../../components/BQATabs/BQATabs";
import { DatePicker } from "@mui/x-date-pickers";
import { useAppDispatch, useAppSelector } from "../../state/store";
import { getDateRangeDisplay } from "../../util/dateUtils";
import { attemptStatuses, challengeTypes } from "../../types/challenges";
import {
  getChallengeStats,
  getDailyChallenge,
} from "../../state/actions/challengeActions";
import { CircularProgress } from "@mui/material";
import { DataTable } from "../../components/DataTable/DataTable";
import { Link } from "react-router";

export function ChallengeHome() {
  useDocumentTitle("Daily Challenges - Bible Quiz Academy");
  const dispatch = useAppDispatch();
  const { dailyChallenges, loading, myHistory } = useAppSelector(
    (state) => state.challenges
  );
  const today = dayjs().tz("America/Los_Angeles");
  const [selectedDay, setSelectedDay] = useState(
    dayjs().tz("America/Los_Angeles")
  );
  const todaySelected = useMemo(
    () => today.format("YYYY-MM-DD") === selectedDay.format("YYYY-MM-DD"),
    [selectedDay]
  );
  const selectedChallenge = dailyChallenges[selectedDay.format("YYYY-MM-DD")];
  const [selectedTab, setSelectedTab] = useState(1);

  useEffect(() => {
    if (selectedTab === 1)
      dispatch(getDailyChallenge(selectedDay.format("YYYY-MM-DD")));
    if (selectedTab === 2) dispatch(getChallengeStats());
  }, [selectedDay, selectedTab]);

  return (
    <div className="page">
      <Row>
        <Link className="secondary-btn" to="/">
          Go Back
        </Link>
        <h1 style={{ marginLeft: 20 }}>Daily Challenges</h1>
      </Row>
      <BQATabs
        tabs={[
          {
            title: "Challenge Statistics",
            key: 1,
          },
          {
            title: "My Stats",
            key: 2,
          },
        ]}
        value={selectedTab}
        onChange={setSelectedTab}
      />
      {selectedTab === 1 && (
        <div>
          <Row style={{ marginBottom: 20 }}>
            <button
              className="link"
              onClick={() => setSelectedDay(selectedDay.subtract(1, "day"))}
            >
              Previous
            </button>
            <div style={{ marginLeft: 8, marginRight: 8 }}>
              <DatePicker
                slotProps={{
                  textField: { size: "small", style: { width: 190 } },
                }}
                value={selectedDay}
                onChange={(value) => {
                  if (value) setSelectedDay(value);
                }}
              />
            </div>
            <button
              className="link"
              onClick={() => setSelectedDay(selectedDay.add(1, "day"))}
            >
              Next
            </button>
            {!todaySelected && (
              <button
                className="link"
                style={{ marginLeft: 20 }}
                onClick={() => setSelectedDay(today)}
              >
                Today
              </button>
            )}
          </Row>
          {selectedChallenge && (
            <div>
              <h2
                style={{ fontSize: 18 }}
              >{`Challenge for ${getDateRangeDisplay(
                selectedDay.format()
              )}`}</h2>
              {todaySelected && !selectedChallenge.myAttempt && (
                <div>
                  <Link
                    className="clickable"
                    to="/attemptchallenge"
                    style={{ width: 300 }}
                  >
                    Attempt Today's Challenge!
                  </Link>
                </div>
              )}
              <p>
                {`${
                  challengeTypes[selectedChallenge.challenge.challengeType]
                } - ${
                  selectedChallenge.challenge.minPass
                    ? `Answer ${selectedChallenge.challenge.minPass} out of ${selectedChallenge.challenge.reps} correctly`
                    : `Answer all ${selectedChallenge.challenge.reps} correctly`
                }`}
              </p>
              {selectedChallenge.myAttempt && (
                <>
                  <p>
                    {`${
                      attemptStatuses[selectedChallenge.myAttempt.attemptStatus]
                    } - ${selectedChallenge.myAttempt.countCorrect} out of ${
                      selectedChallenge.challenge.reps
                    } Correct.`}
                  </p>
                </>
              )}
              {!selectedChallenge.myAttempt && selectedDay <= today && (
                <p>
                  {todaySelected
                    ? "You have not attempted this challenge yet."
                    : "You did not attempt this challenge."}
                </p>
              )}
            </div>
          )}
          {!selectedChallenge && !loading && <p>No challenge for this date.</p>}
          {!selectedChallenge && loading && <CircularProgress />}
        </div>
      )}
      {selectedTab === 2 && (
        <div>
          <p>{`Current Streak: ${myHistory?.streak || 0} Days`}</p>
          <p>{`Longest Streak: ${myHistory?.longestStreak || 0} Days`}</p>
          <DataTable
            data={myHistory?.attempts || []}
            columns={[
              {
                title: "Day",
                render: (obj) => obj.day,
                property: "day",
              },
              {
                title: "Result",
                property: "attemptStatus",
                render: (obj) => attemptStatuses[obj.attemptStatus],
              },
            ]}
          />
        </div>
      )}
    </div>
  );
}
